import { inject } from '@angular/core';
import { ResolveFn, Routes } from '@angular/router';
import { WebkassaCashboxListComponent } from '@adm-web-app/modules/webkassa-cashboxes/list/list.component';
import { WebkassaCashboxEditComponent } from '@adm-web-app/modules/webkassa-cashboxes/edit/webkassa-cashbox-edit.component';
import { WebkassaCashboxService } from '@adm-web-app/services/webkassa-cashbox.service';
import { WebkassaOrgAuthListComponent } from '@adm-web-app/modules/webkassa-cashboxes/org-auths/list/org-auth-list.component';
import { WebkassaOrgAuthEditComponent } from '@adm-web-app/modules/webkassa-cashboxes/org-auths/edit/edit.component';
import { WebkassaCashboxModel, WebkassaOrgAuthModel } from 'hx-services';

const webkassaCashboxResolveFn: ResolveFn<WebkassaCashboxModel> = route => inject(WebkassaCashboxService)
    .getCashboxById(Number(route.paramMap.get('id')));

const webkassaOrgAuthResolveFn: ResolveFn<WebkassaOrgAuthModel> = route => inject(WebkassaCashboxService)
    .getOrgAuthById(Number(route.paramMap.get('id')));

export const webkassCashboxesRoutes: Routes = [
  {
    path: '', component: WebkassaCashboxListComponent,
    data: {
      breadcrumb: 'List'
    }
  },
  {
    path: 'new', component: WebkassaCashboxEditComponent,
    data: {
      breadcrumb: 'Create'
    }
  },
  {
    path: ':id/edit', component: WebkassaCashboxEditComponent,
    resolve: {
      model: webkassaCashboxResolveFn
    },
    data: {
      breadcrumb: 'Edit'
    }
  },
  {
    path: 'org-auths/list', component: WebkassaOrgAuthListComponent,
    data: {
      breadcrumb: 'OrgAuth.List'
    }
  },
  {
    path: 'org-auths/list/new', component: WebkassaOrgAuthEditComponent,
    data: {
      breadcrumb: 'Create'
    }
  },
  {
    path: 'org-auths/list/:id/edit', component: WebkassaOrgAuthEditComponent,
    resolve: {
      model: webkassaOrgAuthResolveFn
    },
    data: {
      breadcrumb: 'Edit'
    }
  },
];
